import React from "react";
import "./NegotiationTable.scss";

export interface TableHeader {
	key: string; // field in data
	label: string; // header display text
	isLeftColumn?: boolean; // show blue styling if true
}

export interface TableRow {
	[key: string]: string | React.ReactNode;
}

interface NegotiationTableProps {
	headers: TableHeader[];
	data: TableRow[];
}

const NegotiationTable: React.FC<NegotiationTableProps> = ({
	headers,
	data,
}) => (
	<div className="table-container">
		<table className="negotiation-table">
			<thead>
				<tr>
					{headers.map((h) => (
						<th
							key={h.key}
							className={h.isLeftColumn ? "left-header" : ""}
						>
							{h.label}
						</th>
					))}
				</tr>
			</thead>
			<tbody>
				{data.map((row, rowIdx) => (
					<tr key={rowIdx}>
						{headers.map((h, colIdx) => {
							const value = row[h.key] ?? "";
							if (h.isLeftColumn) {
								return (
									<td key={colIdx} className="left-column">
										{value}
									</td>
								);
							}
							if (h.key.toLowerCase() === "impact") {
								return (
									<td key={colIdx} className="right-column">
										{value}
									</td>
								);
							}
							return <td key={colIdx}>{value}</td>;
						})}
					</tr>
				))}
			</tbody>
		</table>
	</div>
);

export default NegotiationTable;
